"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneServiceRedirectionBinding = cloneServiceRedirectionBinding;
/**
 * Clones a ServiceRedirectionBinding
 */
function cloneServiceRedirectionBinding(binding) {
    return {
        id: binding.id,
        isSatisfiedBy: binding.isSatisfiedBy,
        moduleId: binding.moduleId,
        serviceIdentifier: binding.serviceIdentifier,
        targetServiceIdentifier: binding.targetServiceIdentifier,
        type: binding.type,
    };
}
//# sourceMappingURL=cloneServiceRedirectionBinding.js.map